import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Container = styled.div`
  padding: 0rem 2rem 2rem;
  .page-body {
    background-color: ${theme.colors.gray2} !important;
  }
`

export const checkButtonStyle = {
  borderRadius: 16,
}
